import React from "react";
import { Switch, Route } from "react-router";
import PastEvents from "./PastEvents/PastEvents";
import UpcomingEvents from "./UpcomingEvents/UpcomingEvents";
import EventDetail from "./EventDetail/EventDetail";
import './EventSection.css';
import { Link } from "react-router-dom";
import { environments } from "environments/environments";

export default class EventSection extends React.Component {
  state = {
    showFuture: true
  }

  componentDidMount(): void {
    document.title = environments.pageTitle +  ' - Akce';
  }

  setUpcomingEventState(showFuture: boolean) {
    this.setState({ showFuture });
  }

  render() {
    return (
      <div className="section">
        <Switch>
          <Route path='/akce' exact render={() => (
            <div>
              <UpcomingEvents />
              <br />
              <Link to="akce/archiv" className="past-events">Minulé akce <span className="archive">(&rarr; archiv)</span></Link>
              <PastEvents preview={true} />
            </div>
          )} />
          <Route path='/akce/archiv' exact component={PastEvents} />
          <Route path='/akce/:year/:month/:day/:title?' component={EventDetail} key={Date.now()} />
        </Switch>
      </div>
    );
  }
}